import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import * as style from "./style.module.css"
import Map from "/src/components/Map"
import PageTop from "/src/components/PageTop"
import json from "/src/siteData.json"
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType"
// import logoUri from "/src/images/icon/logo.png"
import insstagramIcon from "/src/images/icon/sns-instagram-bk.svg"

const data = json.footer
const logoUri = json.header.logoUri
const siteMetaData = json.siteMetadata

const Component = () => {
  return (
    <>
      <PageTop showBelow={900} />
      <footer className={style.footer}>
        <div className={style.footerTop}>
          <Link to="/" className={style.footer_logo}>
            <img
              src={logoUri}
              alt={siteMetaData.title}
              style={{ objectFit: "contain" }}
            />
          </Link>
          <nav className={style.nav}>
            <ul className={style.nav_list}>
              <li className={style.nav_item}>
                <Link to="/">HOME</Link>
              </li>
              <li className={style.nav_item}>
                <Link to={getPathFromTemplateType(4)}>NEWS</Link>
              </li>
              <li className={style.nav_item}>
                ABOUT
                <ul className={style.sub_nav_list}>
                  <li className={style.sub_nav_item}>
                    <Link to="/about-charmanvie">- charmanvie</Link>
                  </li>
                  <li className={style.sub_nav_item}>
                    <Link to="/about-donamarie">- dona marie</Link>
                  </li>
                </ul>
              </li>
              <li className={style.nav_item}>
                <Link to="/concept">CONCEPT</Link>
              </li>
              <li className={style.nav_item}>
                <Link to="/collection">COLLECTIONS</Link>
              </li>
              <li className={style.nav_item}>
                PRODUCT
                <ul className={style.sub_nav_list}>
                  <li className={style.sub_nav_item}>
                    <Link to="/product-charmanvie">- charmanvie</Link>
                  </li>
                  <li className={style.sub_nav_item}>
                    <Link to="/product-donamarie">- dona marie</Link>
                  </li>
                </ul>
              </li>
              <li className={style.nav_item}>
                <Link to="/ranking">RANKING</Link>
              </li>
              <li className={style.nav_item}>
                <Link to="https://www.dona-marie.co.jp/index.html" target="_blank">ONLINE SHOP</Link>
              </li>
              <li className={style.nav_item}>
                <Link to="/preorder">PREORDER</Link>
              </li>
              <li className={style.nav_item}>
                <Link to="/staff">STAFF</Link>
              </li>
              <li className={style.nav_item}>
                <Link to={getPathFromTemplateType(6)}>CONTACT</Link>
              </li>
              <li className={style.nav_item}>
                <Link to={getPathFromTemplateType(5)}>PRIVACY POLICY</Link>
              </li>
              <li className={style.nav_item}>
                <Link to="https://www.instagram.com/donamarie_official/" target="_blank"><img src={insstagramIcon} alt="instagram"/></Link>
              </li>
            </ul>
          </nav>
        </div>
        <small className={style.copyright}>&copy; {data.copyright}</small>
      </footer>
    </>
  )
}

export default Component
